export const initialState = {
  bankingDetails: {
    accountName: '',
    bank: '',
    accountType: '',
    accountNumber: '',
    branchCode: ''
  },
  contactDetails: {
    email: '',
    website: '',
    emergencyContact: {
      name: '',
      phone: ''
    }
  },
  rounds: [],  // Ensure rounds is initialized as an empty array  
  gradingDetails: {
    goldMedalGrade: 80,
    silverMedalGrade: 75,
    bronzeMedalGrade: 70,
    passingGrade: 60,
  },
  imagePath: '',
  imagePathWhite: '',
  selectedRound: 1,
  passportRequired: false,
  competition: null,
  refresh: false,
  termsConditions: '',
  minimumAge: 0,
  nationalApplicationsOpen: true,
  emailsEnabled: true
};

export const settingsReducer = (state, action) => {
  let newState;
  switch (action.type) {
    case 'UPDATE_SETTINGS':
      newState = {
        ...state,
        ...action.payload,
        gradingDetails: action.payload.gradingDetails || state.gradingDetails,
        rounds: action.payload.rounds && action.payload.rounds.length === 3
          ? action.payload.rounds
          : [
            { roundNumber: 1, baseFee: 0, additionalFee: 0 },
            { roundNumber: 2, baseFee: 0, additionalFee: 0 },
            { roundNumber: 3, baseFee: 0, additionalFee: 0 }
          ],
      };
      localStorage.setItem('settings', JSON.stringify(newState)); // Save settings to localStorage  
      break;
    case 'UPDATE_GRADING_DETAILS':
      newState = {
        ...state,
        gradingDetails: {
          ...state.gradingDetails,
          ...action.payload,
        },
      };
      localStorage.setItem('settings', JSON.stringify(newState));
      break;
    case 'UPDATE_COMPETITION':
      newState = {
        ...state,
        selectedCompetition: action.payload
      };
      const { _id, name } = action.payload;
      localStorage.setItem('selectedCompetition', JSON.stringify({ _id, name })); // Save only id and name to localStorage  
      break;
    case 'UPDATE_IMAGE_PATH':
      const { imagePath, imagePathWhite } = action.payload;
      newState = {
        ...state,
        imagePath,
        imagePathWhite
      };
      localStorage.setItem('settings', JSON.stringify(newState)); // Save settings to localStorage  
      break;
    case 'UPDATE_ROUND': // Handle the round update  
      newState = {
        ...state,
        rounds: action.payload // Update rounds  
      };
      localStorage.setItem('settings', JSON.stringify(newState)); // Save settings to localStorage  
      break;
    case 'UPDATE_SELECTED_ROUND': // Handle the selected round update  
      newState = {
        ...state,
        selectedRound: action.payload // Update selected round  
      };
      localStorage.setItem('settings', JSON.stringify(newState)); // Save settings to localStorage  
      break;
    case 'UPDATE_PASSPORT_REQUIRED': // Handle the passport required update  
      newState = {
        ...state,
        passportRequired: action.payload // Update passportRequired  
      };
      localStorage.setItem('settings', JSON.stringify(newState)); // Save settings to localStorage  
      break;
    case 'TRIGGER_REFRESH': // Handle the refresh action  
      newState = {
        ...state,
        refresh: !state.refresh // Toggle the refresh state  
      };
      break;
    case 'UPDATE_NATIONALS_OPEN':
      newState = {
        ...state,
        nationalApplicationsOpen: action.payload
      };
    case 'UPDATE_EMAILS_ENABLED':
      newState = {
        ...state,
        emailsEnabled: action.payload
      }
    default:
      newState = state;
  }
  return newState;
};  